import React, { Fragment } from "react";
import Button from "../Buttons/Button";
import { useAuth } from "../../../context/authContext";

interface CardProps {
  headerLabel: string;
  price: string;
  descriptions: Array<string>;
  buttonLabel: string;
  handleOnClick: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
  handleOnClickGift?: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
  isRedirecting?: boolean;
}

export const Card = ({
  buttonLabel,
  headerLabel,
  price,
  descriptions,
  handleOnClick,
  handleOnClickGift,
  isRedirecting,
}: CardProps) => {
  const {
    state: { user, subscription },
  } = useAuth();
  return (
    <div className="w-full text-center rounded overflow-hidden shadow-lg mb-5 mr-5 no-scrollbar">
      <ul>
        <li className="flex justify-center items-center bg-black text-white w-full h-12 text-lg	">
          {headerLabel}
        </li>
        <li className="flex justify-center items-center bg-slate-300 w-full h-11">
          {price}
        </li>
        <li className="flex justify-center items-center h-16">
          <Button
            className={`w-6/12 h-12 ${isRedirecting || (user && !user.secondary_user && !!subscription) ? 'cursor-no-drop' : 'cursor-pointer'}`}
            type={""}
            onClick={(e) => handleOnClick(e)}
            label={buttonLabel}
            isLoading={isRedirecting}
            disabled={isRedirecting || (user && !user.secondary_user && !!subscription)}
          />
        </li>
        <hr className="m-2"></hr>
        <li className="min-h-fit h-56 overflow-hidden no-scrollbar">
          {descriptions?.length > 0 &&
            descriptions.map((description, index) => (
              <Fragment key={index}>
                <div>{description}</div>
                <hr className="m-2"></hr>
              </Fragment>
            ))}
        </li>

        {handleOnClickGift && (
          <li>
            <button
              className="bg-gray-200 w-36 h-8 rounded m-5"
              onClick={handleOnClickGift}
            >
              Purchase as gift
            </button>
          </li>
        )}
      </ul>
    </div>
  );
};
